import React from 'react'
import { useTranslation } from 'react-i18next'
import { Row, H3, Separator } from '@fs/zion-ui'
import CountHeader from '../../count-header/CountHeader'

const keyMap = {
  spouse: 'info-cards.label.spouse',
  parents: 'info-cards.label.parents',
  children: 'info-cards.label.children',
  siblings: 'info-cards.label.siblings',
}

const FamilyLabel = ({ type, childrenLength }) => {
  const [t] = useTranslation()
  return (
    <>
      <Row gutters="nano" align="middle">
        <H3 size="H6">
          <CountHeader title={t(keyMap[type])} count={childrenLength} />
        </H3>
      </Row>
      <Separator size="nano" />
    </>
  )
}

FamilyLabel.Couple = ({ type }) => {
  return <FamilyLabel type={type === 'couple' ? 'spouse' : 'parents'} />
}

FamilyLabel.Children = ({ type, childrenLength }) => {
  return <FamilyLabel type={type === 'couple' ? 'children' : 'siblings'} childrenLength={childrenLength} />
}

export default FamilyLabel
